<template>
  <div class="w-100 mt-5">
    <div class="row">
      <div class="card text-start p-3 m-2">
        <div class="row">
          <div class="col-12 col-md-12 col-lg-12 col-xl-12 fw-bold" style="border-bottom: 1px solid; border-color: #DEDEDE;">
            Service Level Agreement Configuration <br><br>
          </div>
        </div>
        <div class="row">
          <div class="col-7 col-md-7 col-lg-7 col-xl-7 fw-bold">
          <table class="table" id="myTable">
            <tbody id="tBody">
              <tr>
                <td class="tdBottomless">
                  <label>Response time to Process Order</label>
                  <PopOver :text="responseTimeProcess" class="d-md-inline-block ms-3">
                    <img alt="info" class="info-icon" src="@/assets/ic_info.png" />
                  </PopOver>
                </td>
                <td class="tdBottomless">          
                  <div class="input-group">
                    <input type="number" class="form-control fw-bold" v-model="response_process_order" @keydown="isNumber()" placeholder="0" style="border-right: 0px;"/>
                    <span class="input-group-text" id="basic-addon2" style="background-color: transparent; border-left: 0px;"><b>Regular Hours</b></span>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="tdBottomless">
                  <label>Response time to Pickup Request</label>
                  <PopOver :text="responseTimePickup" class="d-md-inline-block ms-3">
                    <img alt="info" class="info-icon" src="@/assets/ic_info.png" />
                  </PopOver>
                </td>
                <td class="tdBottomless">                  
                  <div class="input-group">
                    <input type="number" class="form-control fw-bold" v-model="response_pickup_request" @keydown="isNumber()" placeholder="0" style="border-right: 0px;"/>
                    <span class="input-group-text" id="basic-addon1" style="background-color: transparent; border-left: 0px;"><b>Regular Hours</b></span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>
      </div>

    </div>
    <div class="mt-1 d-flex justify-content-start">
      <button type="button" class="btn btn-danger text-white shadow-sm rounded fw-bold" @click="submit">
        SAVE CONFIGURATION
      </button>
    </div>
  </div>
</template>

<script>
import PopOver from "@/components/PopOver.vue";

export default {
  components: {
    PopOver
  },
  created() {
    var currentUrl = this.$route.path.split("/");
    this.id = currentUrl[currentUrl.length - 1]
    this.url = currentUrl[currentUrl.length - 2]
    console.log("URL : ", this.url)
  },
  data() {
    return {
      responseTimeProcess: 'Seller/Admin should decide to Proses Order or Batalkan Order, otherwise Order will be automatically cancelled and refund to Buyer is processed',
      responseTimePickup: 'Seller/Admin should Atur Penjemputan, otherwise Order will be automatically cancelled and refund to Buyer is processed',
      response_pickup_request: null,
      response_process_order: null,
    };
  },
  methods: {
    async submit() {
      try {
        const payload = {
          "process_order": parseInt(this.response_process_order),
          "pickup_request": parseInt(this.response_pickup_request)
        }
        await this.$store.dispatch("seller/submitSLA", payload)

        this.$swal({
          icon: 'success',
          title: 'Success',
          text: "SLA configuration has been saved",
          showConfirmButton: false,
          timer: 1500,
        });

      } catch (err) {
        console.log(err)
        this.$swal({
          icon: 'error',
          title: 'Oops...',
          text: "Failed to save SLA configuration has been saved",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    isNumber: (evt) => {
      evt = (evt) ? evt : window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async getSLA() {
      const response = await this.$store.dispatch("seller/getSLA")
      this.response_pickup_request = response.data.data.SLAConfig.pickup_request
      this.response_process_order = response.data.data.SLAConfig.process_order
    },
    close() {
      this.$router.push("/")
    },
  },
  mounted() {
    this.getSLA()
  },
};
</script>

<style scoped>
.tdBottomless{
  border-bottom-width: 0px !important;
  vertical-align: middle;
}
</style>